import type {
  CustomerIdentityDraft,
  CustomerIdentityPreview,
  CustomerIdentitySubTenant,
  CustomerIdentityTenant,
  CustomerIdentityUpdatePayload,
} from '../types/types';

type CustomerIdentityTenantRow = CustomerIdentityTenant | CustomerIdentitySubTenant;

export const createCustomerIdentityDraft = (
  tenant: CustomerIdentityTenantRow
): CustomerIdentityDraft => ({
  primaryColor: tenant.colors?.primaryColor ?? null,
  secondaryColor: tenant.colors?.secondaryColor ?? null,
  logoId: tenant.logoId ?? null,
  logoFile: null,
  logoPreviewUrl: null,
});

export const createCustomerIdentityPreview = (
  tenant: CustomerIdentityTenantRow,
  draft: CustomerIdentityDraft
): CustomerIdentityPreview => ({
  id: tenant.id,
  name: tenant.name,
  logoId: draft.logoId,
  logoPreviewUrl: draft.logoPreviewUrl,
  primaryColor: draft.primaryColor,
  secondaryColor: draft.secondaryColor,
});

export const isCustomerIdentityDraftDirty = (
  draft: CustomerIdentityDraft,
  baseline: CustomerIdentityDraft
) =>
  draft.primaryColor !== baseline.primaryColor ||
  draft.secondaryColor !== baseline.secondaryColor ||
  draft.logoFile !== null ||
  draft.logoId !== baseline.logoId;

export const createCustomerIdentityUpdatePayload = (
  draft: CustomerIdentityDraft,
  baseline: CustomerIdentityDraft
): CustomerIdentityUpdatePayload => {
  const payload: CustomerIdentityUpdatePayload = {};

  if (draft.primaryColor !== baseline.primaryColor) {
    payload.primaryColor = draft.primaryColor;
  }

  if (draft.secondaryColor !== baseline.secondaryColor) {
    payload.secondaryColor = draft.secondaryColor;
  }

  if (draft.logoFile) {
    payload.image = draft.logoFile;
  } else if (draft.logoId !== baseline.logoId) {
    payload.logoId = null;
  }

  return payload;
};
